import { render } from "./PricingCard.vue?vue&type=template&id=5dba35c4&scoped=true"
import script from "./PricingCard.vue?vue&type=script&lang=js"
export * from "./PricingCard.vue?vue&type=script&lang=js"

import "./PricingCard.vue?vue&type=style&index=0&id=5dba35c4&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5dba35c4"

export default script